import { Carousel } from 'antd';
const contentStyle = {
  height: '160px',
  color: '#fff',
  lineHeight: '160px',
  textAlign: 'center',
  background: '#364d79',
};

function HomeDashboard(){

    return (
        <div className="home-dashboard">
        <Carousel autoplay>
            <div >
            <h3 style={contentStyle}>Annoucement</h3>
            </div>
            <div>
            <h3 style={contentStyle}>Usage</h3>
            </div>
            <div>
            <h3 style={contentStyle}>Next Automation</h3>
            </div>
            <div>
            <h3 style={contentStyle}>Alerts</h3>
            </div>
        </Carousel>
        </div>
    );

}

export default HomeDashboard;